<template>
<div class="contractBody">
	<div class="content_table">
		<tableTotal @handleClick="handleClick" :index-show="configTable.indexShow" :config-data="configTable.configData"
			:table-data="configTable.tableData" :loading="configTable.loading"></tableTotal>
		<div class="pagination_box m-t-20">
			<el-pagination @current-change="getData" @size-change="handleSizeChange"
				:current-page.sync="configTable.current" layout="total, sizes, prev, pager, next, jumper" background
				:page-sizes="[10, 15, 20]" :page-size="configTable.pageSize" :total="configTable.total"></el-pagination>
		</div>
	</div>
</div>
</template>

<script>
import tableTotal from "@/components/TableTotal/TableTotal";
export default {
	name: "managementContract",
	components: {
		tableTotal
	},
	data() {
		return {
			newCdisabled: false,
			// 配置表格
			configTable: {
				loading: false,
				indexShow: false,
				configData: [{
					value: 'shopName',
					label: '店铺名称',
					// type: 'img',
					align: 'left'
				}, {
					value: 'id',
					label: '申请ID',
					align: 'left',
					width: '260'
				}, {
					value: 'applyTime',
					label: '申请时间',
					align: 'left'
				}, {
					value: 'checkStatus',
					label: '状态',
					align: 'left',
					objList: {
						0: '待审核',
						1: '审核通过',
						2: '审核不通过',
					}
				}, {
					value: 'checkResultNotice',
					label: '审核描述',
					align: 'left'
				}
					// ,
					// {
					//   label: '操作',
					//   width: '220',
					//   fixed: 'right',
					//   type: 'handleList',
					//   buttonList: [{
					//     label: '重新发起',
					//     event: 'shelvesPut',
					//     show: true,
					//     showText: true,
					//     text: '是否重新编辑当前内容?',
					//     condition: row => {
					//       return (row.status !== 2);
					//     }
					//   }, ]
					// }
				],
				tableData: [],
				current: 1, // 当前页码
				total: 1, // 数据总条数
				pageSize: 10
			}
		};
	},
	computed: {},
	watch: {},
	created() {
		// 生命周期钩子：组件实例创建完成，属性已绑定，但 DOM 还未生成，el 属性还不存在
		this.info();
	},
	methods: {
		info() {
			// 获取数据
			this.getData();
		},
		getData() {
			this.configTable.loading = true;
			var params = {
				"pageNum": this.configTable.current,
				"pageSize": this.configTable.pageSize,
			}
			this.$http.post(this.$const.SellerCenter.shoprecordList, params, true).then((res) => {
				if (res.data) {
					this.configTable.tableData = res.data.list;
					this.configTable.tableData.forEach((item, i) => {
						if (item.checkStatus == 0) {
							this.newCdisabled = true;
						}
					})
				}
				this.configTable.loading = false;
			}).catch((error) => {
				console.log(error, 'error')
			});

		},
		handleClick(event, data, text) {
			switch (event) {
				case 'shelvesPut':
					console.log(event, data, text);
					var strData = JSON.stringify(data)
					this.$emit('sellCenterListDialogSuccess', strData)
					break
			}
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.getData();
		},
		changeStatus(data, index) {
			this.active = index;
		},
	},
};
</script>

<style lang="scss" scoped>
.contractTitle {
	font-weight: 600;
	font-style: normal;
	font-size: 17px;
	color: #333;
	text-align: left;
	line-height: 40px;
	padding-bottom: 10px;
}</style>